// components
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
import useSettings from 'src/hooks/useSettings';

// ----------------------------------------------------------------------

export default function ChangeMode() {
  const { themeMode, onToggleMode } = useSettings();

  return (
    <>
      <IconButtonAnimate
        color={'default'}//{open ? 'primary' : 'default'}
        title={'Change to ' + (themeMode === 'dark' ? 'light' : 'dark') + ' mode'}
        onClick={onToggleMode}
        sx={{
          bgcolor: themeMode === 'light' ? 'common.white' : 'grey.800',
          
        }}
      >
        <Iconify
          icon={themeMode === 'dark' ? 'ph:sun-duotone' : 'ph:moon-duotone'}
          width={20}
          height={20}
        />
      </IconButtonAnimate>
    </>
  );
}
